import React from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider, Empty } from 'antd'
import App from './pages/App'
import { AppContext } from './components/AppContext'

import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './keycloak'
import kcConfig from './kcConfig'

import { CountlyServer } from './countly'
import { registerPatientDeletionDevTool } from './devtools/patientDeletion'

const customizeRenderEmpty = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="" />

if (process.env.NODE_ENV !== 'DEVELOPMENT') {
	CountlyServer()
}

// dev-console-only patient deletion, no UI on purpose
registerPatientDeletionDevTool()

ReactDOM.render(
	<React.StrictMode>
		<ReactKeycloakProvider initOptions={kcConfig.users} authClient={keycloak}>
			<ConfigProvider renderEmpty={customizeRenderEmpty}>
				<AppContext>
					<App />
				</AppContext>
			</ConfigProvider>
		</ReactKeycloakProvider>
	</React.StrictMode>,
	document.getElementById('root')
)
